import { useTheme } from "@mui/material";
import React from "react";

type SelectedStyles = { backgroundColor: string };

/**
 * Returns the styles to be used for the selected state of a table row.
 *
 * @returns An object containing the selected styles and a function to toggle the selected state.
 */
const useSelectedStyles = () => {
  const [selected, setSelected] = React.useState<SelectedStyles>({
    backgroundColor: "",
  });
  const theme = useTheme();

  const onToggle = (isSelected: boolean) => {
    if (isSelected) {
      setSelected((prev) => {
        return { ...prev, backgroundColor: theme.palette.mode === "light" ? "#e5e9eb" : "#5e5e5e" };
      });
    } else {
      setSelected((prev) => {
        return { ...prev, backgroundColor: "unset" };
      });
    }
  };

  return { onToggle, selected };
};

export default useSelectedStyles;
